var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrophicLevel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 13.333V1.667C15 .747 14.252 0 13.333 0H1.667C.747 0 0 .747 0 1.667v11.666C0 14.253.747 15 1.667 15h11.666c.92 0 1.667-.748 1.667-1.667ZM1.666 1.667h11.667v11.666H1.667L1.666 1.667Z",
    fill: "#999"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 6.666v1.667H3V6.666h9Zm-2 3.333v1.667H5V9.999h5Zm0-6.666v1.666H5V3.333h5Z",
    fill: "#999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophicLevel);
export default __webpack_public_path__ + "static/media/trophic-level.21e3a42d5a4e7c8465606603bd413862.svg";
export { ForwardRef as ReactComponent };